import jayzLogoWhite from "@/assets/jayz_logo_white.svg";

const Footer = () => (
  <footer className="bg-jayz-dark py-10 text-white/70">
    <div className="mx-auto max-w-[1320px] px-6">
      <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-xs">
          <img src={jayzLogoWhite} alt="JAYZ Services" className="mb-4 h-12" width={118} height={48} loading="lazy" />
          <p className="text-sm leading-relaxed">
            IT support, software development, and automation solutions for growing businesses.
          </p>
        </div>

        <div className="flex gap-16">
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-white/60">
              Quick Links
            </p>
            <nav className="flex flex-col gap-2">
              <a href="#services" className="text-sm transition-colors hover:text-white">Services</a>
              <a href="#why-us" className="text-sm transition-colors hover:text-white">About</a>
              <a href="#contact" className="text-sm transition-colors hover:text-white">Contact</a>
            </nav>
          </div>

          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-white/60">
              Contact
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <span>(818) 927-2222</span>
              <span>sales@jayz.one</span>
              <span className="max-w-[200px]">10523 Burbank Blvd unit 111, North Hollywood, CA 91601</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 border-t border-white/10 pt-6 text-center text-xs text-white/50">
        © 2021 Jayz Services. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
